var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSegmentMd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 101,
    viewBox: "0 0 67 101",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.7595 0.899902V10.2912C65.7535 10.3152 64.7594 10.3751 63.7654 10.447C34.4466 12.8427 11.2957 37.0158 10.5053 66.7591V66.8429C10.4933 67.2742 10.4813 67.6934 10.4813 68.1246V68.5319C10.4813 68.9632 10.4813 69.4064 10.5053 69.8376C10.5053 70.3407 10.5292 70.8318 10.5532 71.335C10.5771 71.8261 10.6011 72.3172 10.649 72.8083C10.673 73.2995 10.7209 73.7906 10.7807 74.2817C11.4155 80.894 13.2 87.3505 16.0265 93.3279L16.0984 93.292C16.5295 94.2024 16.9966 95.1008 17.4637 95.9872L9.09204 100.815C8.601 99.9282 8.14589 99.0418 7.71473 98.1314C3.24744 88.9557 0.900024 78.8217 0.900024 68.5319C0.900024 32.8353 28.6858 3.51127 63.7654 1.05563C64.7594 0.971775 65.7535 0.92386 66.7595 0.899902Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegmentMd);
export default __webpack_public_path__ + "static/media/segment-md.89747cee.svg";
export { ForwardRef as ReactComponent };